/** Route of the staff pricing cases page. */
export const PRICING_CASES_ADMIN_PATH = "/muggleTestV0/dashboard/admin/pricing-cases";
